import styled from "styled-components";
import {
  FlexContainer,
  FlexSection,
  FlexDiv,
  Button,
} from "../../../components/Atoms";
import Card from "@/components/Atoms/Card";

export const Wrapper = styled(FlexSection)`
  padding: 120px 0 40px;
  background-color: ${({ theme }) => theme.colorsV2.shyft.cream};
  @media only screen and (max-width: 767px) {
    padding: 40px 0 32px;
  }
`;
export const Container = styled(FlexContainer)``;

export const Div = styled(FlexDiv)``;

export const StyledCta = styled(Button)`
  p {
    display: flex;
    align-items: center;
    text-align: center;
  }
`;

export const StyledCard = styled(Card)`
  margin: 0;
  padding: 24px;
  flex-direction: column;
  gap: 24px;
  border-radius: ${({ borderRadius }) => `${borderRadius}`};
  button {
    width: max-content;
  }
`;
